import { createSlice } from "@reduxjs/toolkit";

const persistedSessionStorageReducer = createSlice({
    name:"persistedSessionStorageReducer",
    initialState:{
        markerData:null,
        selectedMeasurementPinReduxState:"",
        selectedMeasurementPinBackupReduxState:"",
        activeMeasurementPin:true
    },
    reducers:{
        setMarkerData:(state,action) => {
            state.markerData = action.payload
        },
        setSelectedMeasurementPinReduxStateAction:(state, action) => {
            state.selectedMeasurementPinReduxState = action.payload
        },
        setSelectedMeasurementPinBackupReduxStateAction:(state, action) => {
            state.selectedMeasurementPinBackupReduxState = action.payload
        },
        setMeasurementPinStatus:(state, action) => {
            state.activeMeasurementPin = action.payload
        }
    }
})

export const { setMarkerData, setSelectedMeasurementPinReduxStateAction, setMeasurementPinStatus, setSelectedMeasurementPinBackupReduxStateAction } = persistedSessionStorageReducer.actions
export default persistedSessionStorageReducer.reducer